import * as React from 'react';
import { css } from 'aphrodite';

import styles from './SVGStyles';

export default class HelocSVG extends React.PureComponent {
  render() {
    return (
      <svg
        className={css(styles.width)}
        height="100px"
        viewBox="0 0 100 100"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        focusable="false"
      >
        <g id="illustration_heloc" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="Group-3" transform="translate(4.000000, 17.000000)">
            <path
              d="M2.5730261,-0.0003 L43.4259692,-0.0003 C44.8476138,-0.0003 46,1.12803571 46,2.52220968 L46,26.4781749 C46,27.8703797 44.8476138,28.9997 43.4259692,28.9997 L2.5730261,28.9997 C1.15138146,28.9997 0,27.8703797 0,26.4781749 L0,2.52220968 C0,1.12803571 1.15138146,-0.0003 2.5730261,-0.0003"
              className={css(styles.actionAccent)}
              fill="#005072"
            />
            <path
              d="M4,20 C3.44771525,20 3,19.5522847 3,19 C3,18.4477153 3.44771525,18 4,18 L18,18 C18.5522847,18 19,18.4477153 19,19 C19,19.5522847 18.5522847,20 18,20 L4,20 Z M4,25 C3.44771525,25 3,24.5522847 3,24 C3,23.4477153 3.44771525,23 4,23 L14,23 C14.5522847,23 15,23.4477153 15,24 C15,24.5522847 14.5522847,25 14,25 L4,25 Z"
              fill="#FFFFFF"
              fillRule="nonzero"
            />
            <polygon fill="#FFFFFF" points="52 67 92 67 92 35 52 35" />
            <path
              d="M18.3382719,61.3403 C19.3522719,61.6433 19.7592719,62.2493 20.7372719,61.8453 C21.4502719,61.5513 21.1712719,60.6093 21.6722719,59.4413 C22.4442719,57.6393 24.6382719,56.9513 26.0992719,57.5363 C27.5602719,58.1213 28.4082719,60.0683 28.7352719,61.6083 C29.0622719,63.1473 28.5312719,65.436 28.3462719,67 L14.7692719,67 C14.7692719,67 13.4882719,64.0223 14.5212719,62.5173 C15.3202719,61.3533 16.9862719,60.9363 18.3382719,61.3403 Z M55,21 L66,21 L66,14.2252 L72,14.2252 L72,21 L79,21 L92,35 L52,35 L39,21 L49,21 L49,14.2252 L55,14.2252 L55,21 Z"
              className={css(styles.action)}
              fill="#0098DA"
            />
            <path
              d="M0,12 L0,6 L46,6 L46,12 L0,12 Z M28,35 L39,21 L52,35 L52,67 L28,67 L28,35 Z"
              className={css(styles.grey)}
              fill="#BFCCD4"
            />
            <path
              d="M36.0244584,59.0739037 C36.2279525,57.3439393 37.7062194,56 39.5004892,56 C41.2937806,56 42.7720475,57.3439393 42.9765199,59.0739037 L43,67 L36,67 L36.0244584,59.0739037 Z M70,48 L70,41 L74,41 L74,48 L70,48 Z M80,48 L80,41 L84,41 L84,48 L80,48 Z M60,48 L60,41 L64,41 L64,48 L60,48 Z M70,61 L70,54 L74,54 L74,61 L70,61 Z M80,61 L80,54 L84,54 L84,61 L80,61 Z M60,61 L60,54 L64,54 L64,61 L60,61 Z"
              className={css(styles.actionAccent)}
              fill="#005072"
            />
          </g>
        </g>
      </svg>
    );
  }
}
